
import tagableMixin from "~/mixins/tagableMixin";

export default {
  mixins: [tagableMixin],

  props: {
    selectedVariant: { type: Object, default: () => {} },
    tags: { type: Array, default: () => [] },
    productId: { type: String, default: "" },
    reviewImage: { type: Object, default: () => {} },
    assemblyInstructionsHtml: {
      type: String,
      default: "",
    },
  },

  computed: {
    comProperties() {
      const {
        width,
        height,
        depth,
        dimensionsIcon,
        variant_weight: variantWeight,
      } = this.selectedVariant;

      return {
        width,
        height,
        depth,
        variantWeight,
        tags: this.tags,
        dimensionsIcon,
      };
    },
    featurePanels() {
      let featurePanels = [];
      if (this.productHasSize) {
        featurePanels.push({
          title: this.selectedVariant?.variant_weight
            ? "dimensions & weight"
            : "dimensions",
          component: "PdpDimension",
          props: this.comProperties,
        });
      }

      if (this.selectedVariant.warranty) {
        featurePanels.push({
          title: "product care",
          component: "PdpCareWarranty",
          props: {},
        });
      }

      if (this.assemblyInstructionsHtml) {
        featurePanels.push({
          title: "assembly instructions",
          component: "PdpAssemblyInstructions",
          props: {
            html: this.assemblyInstructionsHtml,
          },
        });
      }

      if (this.selectedVariant.delivery_truck) {
        featurePanels.push({
          title: "2 person delivery service",
          component: "PdpDeliveryService",
          props: {},
        });
      }

      if (this.productId) {
        featurePanels.push({
          id: "pdp-reviews-accordion",
          title: "reviews",
          component: "PdpReviewContainer",
          useVShow: true,
          props: {
            productId: this.productId,
            selectedVariant: this.selectedVariant,
            image: this.reviewImage,
          },
        });
      }
      return featurePanels;
    },
    productHasSize() {
      return (
        this.selectedVariant.width != null &&
        this.selectedVariant.height != null &&
        this.selectedVariant.depth != null
      );
    },
  },
};
